import apiClient from '@/plugins/api-client';
import { getKeycloak } from '@/helpers/keycloak';
import { useSnackbarStore } from '@/store/snackbar';
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';

export function useApi() {
  const { t } = useI18n();
  const { showError } = useSnackbarStore();

  const loading = ref(false);

  const apiGet = (url, responseType = 'json', shouldShowError = true) => apiRequest({
    method: 'get',
    url,
    responseType,
  }, shouldShowError);

  const apiPost = (url, data, shouldShowError = true) => apiRequest({
    method: 'post',
    url,
    data,
  }, shouldShowError);

  const apiRequest = async (options, shouldShowError = true) => {
    loading.value = true;

    try {
      const headers = { Authorization: `Bearer ${(await getKeycloak()).token}` };
      options.headers = {
        ...options.headers,
        ...headers,
      };

      const response = await apiClient.request(options);

      return response.data.data ?? response;
    } catch (error) {
      if (shouldShowError) {
        showError(error.response?.data?.message ?? t('genericServerError'));
      } else {
        throw new Error(error);
      }
    } finally {
      loading.value = false;
    }
  };

  return {
    loading,
    apiGet,
    apiPost,
    apiRequest,
  };
}
